// app/javascript/controllers/file_input_controller.js
import { Controller } from "@hotwired/stimulus"

// Provides a custom, localized UI for file inputs using a hidden input + button + filename display.
export default class extends Controller {
  static targets = ["input", "filename", "button"]
  static values = {
    noText: String, // Text when no file selected
    multipleText: String // Template with __COUNT__ for multiple files
  }

  connect() {
    this.updateFilename()
  }

  browse() {
    if (this.hasInputTarget) this.inputTarget.click()
  }

  update() {
    this.updateFilename()
  }

  updateFilename() {
    if (!this.hasFilenameTarget || !this.hasInputTarget) return
    const files = this.inputTarget.files
    if (!files || files.length === 0) {
      this.filenameTarget.textContent = this.noTextValue || "No file chosen"
      return
    }
    if (files.length === 1) {
      this.filenameTarget.textContent = files[0].name
    } else {
      const template = this.multipleTextValue || "__COUNT__ files selected"
      this.filenameTarget.textContent = template.replace("__COUNT__", files.length)
    }
  }
}
